import React from 'react';
import { AlertTriangle, CheckCircle2 } from 'lucide-react';

import { Button } from '../ui/button';
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle
} from '../ui/dialog';

export interface SubmissionResultModalV2Props {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	variant: 'success' | 'error';
	title: string;
	message: string;
	primaryActionLabel: string;
	onPrimaryAction: () => void;
	footerContent?: React.ReactNode;
}

const SubmissionResultModalV2 = ({
	open,
	onOpenChange,
	variant,
	title,
	message,
	primaryActionLabel,
	onPrimaryAction,
	footerContent
}: SubmissionResultModalV2Props) => {
	const isSuccess = variant === 'success';
	const Icon = isSuccess ? CheckCircle2 : AlertTriangle;

	const handlePrimaryAction = () => {
		onPrimaryAction();
		onOpenChange(false);
	};

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent>
				<div className="individual-v2 -m-6 p-6 rounded-lg">
					<DialogHeader className="items-center text-center">
						<div
							className={`flex items-center justify-center w-16 h-16 rounded-full ${
								isSuccess ? 'bg-green-100' : 'bg-red-100'
							}`}
						>
							<Icon className={`h-8 w-8 ${isSuccess ? 'text-arca-dark-green' : 'text-red-600'}`} />
						</div>
						<DialogTitle className="font-heading text-center">{title}</DialogTitle>
						<DialogDescription className="text-center">{message}</DialogDescription>
					</DialogHeader>

					<DialogFooter className="mt-4">
						<Button
							type="button"
							className="w-full h-11 bg-arca-dark-green hover:bg-arca-dark-green/90 text-white font-medium"
							onClick={handlePrimaryAction}
						>
							{primaryActionLabel}
						</Button>
					</DialogFooter>

					{footerContent && (
						<p className="mt-2 text-center text-xs text-gray-500">{footerContent}</p>
					)}
				</div>
			</DialogContent>
		</Dialog>
	);
};

export default SubmissionResultModalV2;
